<template>
  <div class="main-app">
    <div id="downloadable-iframe"></div>
    <Toast position="top-right" group="toastMessage" />
    <ConfirmDialog group="confirmDialog" />
    <router-view />
    <uploadProgress ref="uploadProgress" />
  </div>
</template>